import React from "react";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import {
  FaLinkedin,
  FaGithub,
  FaInstagram,
  FaDownload,
  FaWhatsapp,
} from "react-icons/fa";
import { HiSparkles } from "react-icons/hi";
import "./Mainpage.css";

const Mainpage = () => {
  const socialLinks = [
    {
      icon: <FaLinkedin />,
      url: "https://www.linkedin.com/in/willy-oktodinata-955081290/",
      color: "#0A66C2",
    },
    {
      icon: <FaGithub />,
      url: "https://github.com/WillyOctz",
      color: "#ffffff",
    },
    {
      icon: <FaInstagram />,
      url: "https://www.instagram.com/willy.z999?igsh=ajczeWRtZGx3NHVn",
      color: "#E4405F",
    },
    {
      icon: <FaWhatsapp />,
      url: "https://wa.me/+6285857321597",
      color: "#25D366",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8, rotate: -10 },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  return (
    <div className="mainpage-container">
      <motion.div
        className="mainpage-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Left Section */}
        <div className="mainpage-left">
          {/* Social Links */}
          <motion.div variants={itemVariants} className="social-links">
            {socialLinks.map((social, i) => (
              <motion.a
                key={i}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                whileHover={{
                  scale: 1.2,
                  rotate: 5,
                  color: social.color,
                }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "string", stiffness: 400, damping: 10 }}
              >
                {social.icon}
              </motion.a>
            ))}
          </motion.div>

          {/* Greeting */}
          <motion.div variants={itemVariants} className="greeting">
            <motion.div
              className="greeting-badge"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5 }}
            >
              <HiSparkles className="sparkle-icon" />
              <span>Available for work</span>
            </motion.div>
            <h1 className="greeting-text">
              Nice to meet you,
              <br />
              I'm <span className="gradient-text">Willy Oktodinata</span>
            </h1>
          </motion.div>

          {/* Role Animation */}
          <motion.div variants={itemVariants} className="role-container">
            <div className="role-wrapper">
              <Typewriter
                options={{
                  strings: [
                    "AI/ML Engineer",
                    "Backend Developer",
                    "IT Support Specialist",
                    "Data Analyst",
                    "Data Engineer",
                  ],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 50,
                  delay: 80,
                }}
              />
            </div>
          </motion.div>

          {/** Description */}
          <motion.p variants={itemVariants} className="description">
            Passionate about creating innovative solutions through artificial
            intelligence and cutting-edge web technologies, And eager to learn
            and develop more of my skills in that field.Also good at solving
            technical problems and providing IT Support.
            <br />
            Preferably looking for Remote position. 😀
          </motion.p>

          {/* CTA Buttons */}
          <motion.div variants={itemVariants} className="cta-buttons">
            <motion.a
              href="/CV_Willy-Oktodinata_High-ATS.docx"
              download="Willy_Oktodinata_CV.docx"
              className="btn-modern btn-primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaDownload />
              <span>Download CV</span>
            </motion.a>
            <motion.a
              href="#contact"
              className="btn-modern btn-secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span>Get in Touch</span>
            </motion.a>
          </motion.div>

          {/* Stats */}
          <motion.div variants={itemVariants} className="stats-container">
            <div className="stat-item">
              <motion.h3
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.2, type: "spring" }}
                className="gradient-text"
              >
                5+
              </motion.h3>
              <p>Years of Work Experience</p>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <motion.h3
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.6, type: "spring" }}
                className="gradient-text"
              >
                10+
              </motion.h3>
              <p>Skills Mastered</p>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <motion.h3
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 2, type: "spring" }}
                className="gradient-text"
              >
                1+
              </motion.h3>
              <p>Projects Deployed</p>
            </div>
          </motion.div>
        </div>

        {/* Right Content - Profile Pict */}
        <motion.div className="mainpage-right" variants={imageVariants}>
          <div className="profile-wrapper">
            {/* Animated Rings */}
            <motion.div
              className="profile-ring ring-1"
              animate={{
                rotate: 360,
                scale: [1, 1.05, 1],
              }}
              transition={{
                rotate: { duration: 20, repeat: Infinity, ease: "linear" },
                scale: { duration: 3, repeat: Infinity, ease: "easeInOut" },
              }}
            />
            <motion.div
              className="profile-ring ring-2"
              animate={{
                rotate: -360,
                scale: [1, 0.95, 1],
              }}
              transition={{
                rotate: { duration: 15, repeat: Infinity, ease: "linear" },
                scale: { duration: 4, repeat: Infinity, ease: "easeInOut" },
              }}
            />

            {/** Profile Image */}
            <motion.div
              className="profile-image"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <div className="profile-image-inner" />

              {/* Floating Elements */}
              <motion.div
                className="floating-element element-1"
                animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                🎨
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Mainpage;
